export const maskClick = (...fields) => ({
  methods: {
    mask_click_hide() {
      fields.forEach(field => {
        this[field] = false
      });
    }
  },
  mounted() {
    document?.addEventListener('click', this.mask_click_hide, false);
  },
  beforeDestroy() {
    document?.removeEventListener('click', this.mask_click_hide, false);
  }
})

